import { makeActionCreator } from '../../../config/store/utils';
import { getStateFatigue } from '../../../services/security';


export const GET_STATE_FATIGUE = 'GET_STATE_FATIGUE';
export const GET_STATE_FATIGUE_ERROR = 'GET_STATE_FATIGUE_ERROR';
export const GET_STATE_FATIGUE_SUCCESS = 'GET_STATE_FATIGUE_SUCCESS';
export const onGetStateFatigue = makeActionCreator(GET_STATE_FATIGUE);
export const onGetStateFatigueError = makeActionCreator(
    GET_STATE_FATIGUE_ERROR,
    'payload'
);
export const onGetStateFatigueSuccess = makeActionCreator(
    GET_STATE_FATIGUE_SUCCESS,
    'payload'
);

// Modificar el `onGetAsarcoThunk` para recibir el parámetro `shift`.
export const onGetStateFatigueThunk = () => async dispatch => {
    dispatch(onGetStateFatigue());
    try {
        // Llamar a la API y obtener los datos
        const { data } = await getStateFatigue();
        
        // Acceder a datos_historicos que es donde está el array
        const datosHistoricos = data.datos_historicos || [];

        const state = datosHistoricos.map((item, index) => ({
            ...item,
            id: `${index + 1}`,
        }));

        return dispatch(
            onGetStateFatigueSuccess({
                lista: state,
            })
        );
    } catch (error) {
        console.log(error);
        return dispatch(
            onGetStateFatigueError({
                error: error,
            })
        );
    }
};